module.exports = __webpack_public_path__ + "static/img/icon_default_head.9fc3f15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/icon_default_head.png
// module id = jzHP
// module chunks = 28